import React from "react";
import { CallbackComponent } from "redux-oidc";
import { useNavigate } from "react-router-dom";

const MyCallbackPage = (props) => {
  const navigate = useNavigate();

  const successCallback = (user) => {
    console.log("Success callback", user);
    navigate("/");
  };

  const errorCallback = (err) => {
    //HACK: This seems to be called before succes.
    console.log("Error callback", err);
    // handleError(err);
  };

  return (
    <CallbackComponent
      userManager={props.userManager}
      successCallback={successCallback}
      errorCallback={errorCallback}
    >
      <div> Redirecting...</div>
    </CallbackComponent>
  );
};

export default MyCallbackPage;
